import UserPartnerAccountCreateForm from './UserPartnerAccountCreateForm';

export default UserPartnerAccountCreateForm;
